import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { LocationContext, RouterContext } from 'common/containers/RouterContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import devURL from 'common/util/devURL';
import withContexts from 'common/util/withContexts';

import Button from '../inputs/Button';
import Link from '../Link';
import NavLogo from '../NavLogo';
import Tappable from '../Tappable';
import LandingDropdown from '../www/LandingDropdown';

import 'css/components/www/_LandingNavV2.scss';

class LandingNavV2 extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    navStyle: PropTypes.string,
    router: PropTypes.object,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  static defaultProps = {
    navStyle: '',
  };

  state = {
    mobileNavOpen: false,
  };

  onLoginTapped = () => {
    this.setState({
      mobileNavOpen: false,
    });

    const { router, viewer } = this.props;
    const { companies } = viewer;
    if (viewer && viewer.companies && viewer.companies.length === 0) {
      // logged in && no companies -> create a company
      router.push('/register');
      return;
    } else if (!viewer || viewer.loggedOut) {
      // logged out -> sign in
      router.push('/login');
      return;
    } else {
      // logged in && has company -> admin dashboard
      // assume first company without redirection url for now
      const company = companies.find((c) => !c.integrationAuthRedirectionURL) ?? companies[0];
      const companyURL =
        company.integrationAuthRedirectionURL ??
        devURL(`https://${company.subdomain}.canny.io/admin`);
      window.location.assign(companyURL);
    }
  };

  onMobileLinkClicked = () => {
    this.setState({
      mobileNavOpen: false,
    });
  };

  onMobileNavOpen = () => {
    this.setState({
      mobileNavOpen: !this.state.mobileNavOpen,
    });
  };

  renderMobileLandingNav() {
    var className = 'menuButton';
    if (this.state.mobileNavOpen) {
      className += ' open';
    }

    return (
      <div className="landingMobileNav">
        <Tappable onTap={this.onMobileNavOpen}>
          <div className={className}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </Tappable>
        {this.renderMobileNavOptions()}
      </div>
    );
  }

  renderMobileNavOptions() {
    const { mobileNavOpen } = this.state;
    if (!mobileNavOpen) {
      return null;
    }

    return (
      <div className="options">
        <Link
          activeClassName="active"
          className="link"
          onTap={this.onMobileLinkClicked}
          to="/features">
          Features
        </Link>
        <Link
          activeClassName="active"
          className="link"
          onTap={this.onMobileLinkClicked}
          to="/use-cases">
          Use Cases
        </Link>
        <Link
          activeClassName="active"
          className="link"
          onTap={this.onMobileLinkClicked}
          to="/pricing">
          Pricing
        </Link>
        <a href="https://canny.io/blog/" className="link">
          Blog
        </a>
        <Link
          activeClassName="active"
          className="link"
          onTap={this.onMobileLinkClicked}
          to="/case-studies">
          Case Studies
        </Link>
        {this.renderRightCTA()}
        <Link
          activeClassName="active"
          className="link"
          onTap={this.onMobileLinkClicked}
          to="/request-demo">
          Request a demo
        </Link>
      </div>
    );
  }

  renderRightCTA() {
    const {
      location: { pathname },
      navStyle,
    } = this.props;
    if (navStyle === 'fixedNav') {
      return (
        <div className="desktop">
          <Link className="link" to="/register">
            <Button buttonType="greenButton" value="Sign Up" />
          </Link>
          <Link
            activeClassName="active"
            className="link"
            onTap={this.onMobileLinkClicked}
            to="/request-demo">
            <Button buttonType="ghostButton" value="Request A Demo" />
          </Link>
        </div>
      );
    } else if (pathname === '/') {
      return (
        <div className="desktop">
          <Link className="link" fakeLink={true} onTap={this.onLoginTapped} to="/login">
            Log&nbsp;in
          </Link>
          <Link className="link" to="/register">
            <Button buttonType="greenButton" value="Sign Up" />
          </Link>
        </div>
      );
    } else if (pathname !== '/') {
      return (
        <div className="desktop">
          <Link className="link" to="/register">
            Sign&nbsp;Up
          </Link>
          <Link
            activeClassName="active"
            className="link"
            onTap={this.onMobileLinkClicked}
            to="/request-demo">
            <Button buttonType="ghostButton" value="Request A Demo" />
          </Link>
        </div>
      );
    }

    return (
      <Link className="link" fakeLink={true} onTap={this.onLoginTapped} to="/login">
        Log&nbsp;in
      </Link>
    );
  }

  render() {
    const { navStyle } = this.props;
    const className = 'landingNavV2 ' + navStyle;
    return (
      <div className={className}>
        <div className="container">
          <div className="left">
            <NavLogo style={navStyle} />
          </div>
          <div className="middle">
            <LandingDropdown
              options={[
                { name: 'Features', to: '/features', type: 'linkHeading' },
                { name: 'Collect Feedback', to: '/features/collect-feedback' },
                { name: 'Analyze Feedback', to: '/features/analyze-feedback' },
                { name: 'Plan Roadmap', to: '/features/product-roadmap' },
                { name: 'Share Updates', to: '/features/product-changelog' },
                { name: 'Use Cases', to: '/use-cases', type: 'linkHeading' },
                { name: 'Feature Request Management', to: '/use-cases/feature-request-management' },
                { name: 'Idea Management', to: '/use-cases/idea-management' },
                { name: 'Internal Feedback', to: '/use-cases/internal-feedback' },
                { name: 'Product Management', to: '/use-cases/product-management' },
                { name: 'Sales Documentation', to: '/use-cases/sales-documentation' },
                { name: 'Public Roadmap', to: '/use-cases/public-roadmap' },
                { name: 'Customer Feedback', to: '/use-cases/customer-feedback' },
                { name: 'Integrations', to: '/integrations', type: 'soloOption' },
              ]}
              trigger="Product"
            />
            <Link activeClassName="active" className="link" to="/pricing">
              Pricing
            </Link>
            <LandingDropdown
              options={[
                { name: 'Learn', type: 'heading' },
                { name: 'Canny Blog', to: 'https://canny.io/blog', type: 'external' },
                {
                  name: 'Product Chats Podcast',
                  to: 'https://productchats.canny.io',
                  type: 'external',
                },
                {
                  name: 'Free Prioritization Spreadsheet',
                  to: 'https://go.canny.io/free-prioritization-template',
                  type: 'external',
                },
                {
                  name: 'Guide to Managing User Feedback',
                  to: 'https://go.canny.io/being-canny-guide',
                  type: 'external',
                },
                { name: 'Documentation', type: 'heading' },
                {
                  name: 'Install Canny',
                  to: 'https://developers.canny.io/install',
                  type: 'external',
                },
                {
                  name: 'API Docs',
                  to: 'https://developers.canny.io/api-reference',
                  type: 'external',
                },
                { name: 'Other Resources', type: 'heading' },
                { name: 'Help Center', to: 'https://help.canny.io/en/', type: 'external' },
                { name: 'Feedback', to: 'https://feedback.canny.io', type: 'external' },
                { name: 'Security', to: '/security' },
              ]}
              trigger="Resources"
            />
            <Link activeClassName="active" className="link" to="/case-studies">
              Case Studies
            </Link>
          </div>
          <div className="right">
            {this.renderRightCTA()}
            <div className="mobile">{this.renderMobileLandingNav()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withContexts({
  location: LocationContext,
  router: RouterContext,
  viewer: ViewerContext,
})(LandingNavV2);
